export default __webpack_public_path__ + "static/media/login-bg.b9c4f6d7.jpeg";